import React from 'react';
import { CreditCardIcon, UploadIcon, CalendarIcon, LinkIcon, ShieldCheckIcon, ShoppingBagIcon, RepeatIcon } from 'lucide-react';
import { PaymentType } from './PaymentForm';
interface PaymentTypeSelectorProps {
  activeType: PaymentType;
  onChange: (type: PaymentType) => void;
}
const paymentTypes = [{
  id: 'standard',
  name: 'Single',
  description: 'Create a one-time payment link for a specific amount',
  icon: CreditCardIcon
}, {
  id: 'bulk',
  name: 'Bulk',
  description: 'Upload a CSV to create multiple payment requests at once',
  icon: UploadIcon
}, {
  id: 'installment',
  name: 'Split',
  description: 'Divide a payment into multiple installments or recipients',
  icon: CalendarIcon
}, {
  id: 'fixed-links',
  name: 'Fixed Links',
  description: 'Create a static reusable link to collect multiple payments',
  icon: LinkIcon
}, {
  id: 'card-on-file',
  name: 'Charge',
  description: 'Charge a saved card on file for an existing customer',
  icon: CreditCardIcon
}, {
  id: 'preauth',
  name: 'Security Hold',
  description: "Place a temporary authorization hold on a customer's card",
  icon: ShieldCheckIcon
}, {
  id: 'shop-products',
  name: 'Shop',
  description: 'Select products for customers to pay through your shop',
  icon: ShoppingBagIcon
}, {
  id: 'recurring',
  name: 'Recurring',
  description: 'Set up automatic recurring billing or subscriptions',
  icon: RepeatIcon
}];
export function PaymentTypeSelector({
  activeType,
  onChange
}: PaymentTypeSelectorProps) {
  return <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3" data-id="element-7542">
      {paymentTypes.map(type => {
      const Icon = type.icon;
      const isActive = activeType === type.id;
      return <button key={type.id} onClick={() => onChange(type.id as PaymentType)} className={`relative flex items-start gap-3 p-4 rounded-xl border text-left transition-all ${isActive ? 'border-[#E2231A] bg-[#E2231A]/[0.03] ring-1 ring-[#E2231A]' : 'border-gray-200 bg-white hover:border-gray-300'}`} data-id="element-7543">
            {/* Radio indicator */}
            <div className="mt-0.5 flex-shrink-0" data-id="element-7544">
              <div className={`w-[18px] h-[18px] rounded-full border-2 flex items-center justify-center transition-colors ${isActive ? 'border-[#E2231A]' : 'border-gray-300'}`} data-id="element-7545">
                {isActive && <div className="w-2.5 h-2.5 rounded-full bg-[#E2231A]" data-id="element-7546" />}
              </div>
            </div>

            {/* Content */}
            <div className="min-w-0 flex-1" data-id="element-7547">
              <div className="flex items-center gap-2 mb-1" data-id="element-7548">
                <Icon size={15} className={isActive ? 'text-[#9F140F]' : 'text-gray-400'} data-id="element-7549" />

                <span className={`text-sm font-semibold ${isActive ? 'text-gray-900' : 'text-gray-700'}`} data-id="element-7550">
                  {type.name}
                </span>
              </div>
              <p className="text-xs text-gray-500 leading-relaxed" data-id="element-7551">
                {type.description}
              </p>
            </div>
          </button>;
    })}
    </div>;
}